import { deepFreeze } from '@sm/utils';

import { createErrorMessageId } from '../helpers';
import {
  AnswerValidationResultType,
  DeepReadOnly,
  ValidationMessageType,
  ValidationStatus,
  ValidationStatuses,
} from '../types';

class AnswerValidationResult implements AnswerValidationResultType {
  readonly #status: ValidationStatuses;

  readonly #messages: DeepReadOnly<ValidationMessageType[]>;

  constructor(status: ValidationStatuses, messages?: ValidationMessageType[]) {
    this.#status = status;

    // clone and make read-only messages
    this.#messages = deepFreeze(Array.from(messages?.length ? [...messages] : []));

    if (!this.isValid() && !this.#messages.length) {
      throw new Error(createErrorMessageId('no messages provided'));
    }
  }

  get status(): ValidationStatuses {
    return this.#status;
  }

  get messages(): DeepReadOnly<ValidationMessageType[]> {
    return this.#messages;
  }

  isValid(): boolean {
    return this.#status === ValidationStatus.OK;
  }

  getFirstMessage(): ValidationMessageType | undefined {
    return this.#messages[0];
  }
}

export default AnswerValidationResult;
